module.exports = __webpack_public_path__ + "static/media/NewDesignHrMissing.960ab29c.svg";